// K+
import Constants from "../../api/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";

// Vendor
import {useI18n} from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ButtonComponent from '../../components/button/index';
import ImageTextBox from "../../components/image-text-box/index";

export default {
    name: "home",
    components: {
        HeaderComponent,
        FooterComponent,
        ButtonComponent,
        ImageTextBox
    },
    data() {
        return {
            promoApi: new PromoApi({
                endpoint: window.API_ENDPOINT + "/api/mulinobianco/2.0/web/promo-engine/",
                promoCode: Constants.API_PROMOCODE
            }),
            years: [
                {
                    id: '2022',
                    url: '/lacartadelmulino/fiori-del-mulino/2022/home',
                    label: 'Edizione 2022',
                    visible: true
                },
                {
                    id: '2023',
                    url: '/lacartadelmulino/fiori-del-mulino/2023/home',
                    label: 'Edizione 2023',
                    visible: true
                },
                {
                    id: '2024',
                    url: '/lacartadelmulino/fiori-del-mulino/2024/home',
                    label: 'Edizione 2024',
                    visible: true
                },
                {
                    id: '2025',
                    url: '/lacartadelmulino/fiori-del-mulino/2025/home',
                    label: 'Edizione 2025',
                    visible: true
                },
                {
                    id: '2026',
                    url: '/lacartadelmulino/fiori-del-mulino/2026/home',
                    label: 'Edizione 2026',
                    visible: true
                }
            ],
            boxes: [
                {
                    id: '1',
                    imagePath: 'sections/box-biscotti.png',
                    title: 'Oltre 100 prodotti',
                    description: 'conformi alla Carta del Mulino',
                    titleBefore: true
                },
                {
                    id: '2',
                    imagePath: 'sections/box-ape.png',
                    title: 'Con 600.00',
                    description: 'api da miele nello stabilimento di Parma',
                    titleBefore: false
                },
                {
                    id: '3',
                    imagePath: 'sections/box-aziende.png',
                    title: 'da 500 a 2.600',
                    description: 'aziende coivolte in 4 anni',
                    titleBefore: false
                },
                {
                    id: '4',
                    imagePath: 'sections/box-farina.png',
                    title: '240.000',
                    description: 'tonnellate di farina sostenibile',
                    titleBefore: true
                },
                {
                    id: '5',
                    imagePath: 'sections/box-mulino.png',
                    title: '600',
                    description: 'Mulini dedicati alle api',
                    titleBefore: true
                },
                {
                    id: '6',
                    imagePath: 'sections/box-fiori.png',
                    title: '1.800',
                    description: 'ettari di campi fioriti',
                    titleBefore: false
                },
            ]
        }
    },
    setup() {
        const {t} = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return {t}
    }
}